export default {
  getPolicyFilter: state => state.filter,
  getPolicyList: state => state.list,
  getPolicyValidation: state => state.validation,
  getPolicyResult: state => state.result,
};
